import React from "react";
import "./Loader.scss";
import { isMobile, isIos } from "../../../services/agent";
import { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import { useState } from "react";
import { useEffect } from "react";

const Loader = (props) => {

  const { currentAudioTime, songPlaying, currentAudioDuration } = useContext(AppContext);
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    if (props.songId == songPlaying) {
      setPercent((currentAudioTime / currentAudioDuration) * 100);
    }
  }, [currentAudioTime, currentAudioDuration])

  const circleConfig = {
    viewBox: "0 0 38 38",
    x: "19",
    y: "19",
    radio: "15.91549430918954",

  };
  return (
    <figure className="loader-base">
      <svg viewBox={circleConfig.viewBox}>


        <circle
          className="path"
          cx={circleConfig.x}
          cy={circleConfig.y}
          r={circleConfig.radio}
          fill="transparent"
          stroke="#7e05c7"
          strokeDasharray={`${percent} ${100 - percent}`}
          strokeDashoffset="25"
        />
      </svg>
    </figure>
  );
};

export default Loader;
